<app-base-dialog
	sizeClass="size-47"
	[topBarTemplate]="topBar"
	[bottomBarLeftTemplate]="bottomBarLeft"
	[bottomBarRightTemplate]="bottomBarRight"
	[multiRow]="true"
	[scrollable]="true"
	[bottomBorder]="true"
>
	<ng-template #topBar>
		<app-dialog-header title="Data export"></app-dialog-header>
		<app-dialog-selection-bar [(selection)]="currentTabSelection" [selections]="tabSelections"></app-dialog-selection-bar>
	</ng-template>
	@switch (currentTabSelection()) {
		@case (DataExportSelection.KOLOMSELECTIE) {
			<div class="top">
				<div class="top-left">
					<h3>Selecteer kolommen</h3>
					<app-checkbox label="Toon alleen selectie ({{ kolommenSelection().length }})" [(value)]="showSelection"> </app-checkbox>
				</div>
				<app-button buttonType="secondary" icon="favoriet" (clickit)="saveSelectionAsFavoriet()">Opslaan als favoriet</app-button>
			</div>
			<div class="controls">
				<app-instant-search-box
					[value]="kolomFilter()"
					(fire)="kolomFilter.set($event); showSelection.set(false)"
					placeholder="Zoek naar een kolomnaam"
				>
				</app-instant-search-box>
			</div>
			<div class="categorieen">
				@for (categorie of filteredCategorieen(); track categorie.name) {
					<app-data-export-categorie
						[categorie]="categorie"
						[selection]="kolommenSelection()"
						(categorieSelected)="changeCategorieSelection($event)"
						(columnSelected)="changeColumnSelection($event)"
						[first]="$first"
					>
					</app-data-export-categorie>
				} @empty {
					<div class="no-results">Geen kolommen</div>
				}
			</div>
		}
		@case (DataExportSelection.FAVORIETEN) {
			<div class="top">
				<div class="top-left">
					<h3>Mijn favorieten</h3>
				</div>
			</div>
			<div class="controls">
				<app-instant-search-box [value]="favorietFilter()" (fire)="favorietFilter.set($event)" placeholder="Zoek op naam van favoriet">
				</app-instant-search-box>
			</div>
			<div class="favorieten">
				@for (favoriet of filteredFavorieten(); track favoriet.id) {
					<app-data-export-row
						[primary]="favoriet.naam"
						[secondary]="favoriet.fieldNames"
						[selected]="isFavorietSelected(favoriet)"
						[inCategorie]="false"
						(selectedChange)="changeFavorietSelection(favoriet)"
						[showEditDelete]="true"
						[first]="$first"
						(editClicked)="editFavoriet(favoriet)"
						(deleteClicked)="deleteFavoriet(favoriet)"
					>
					</app-data-export-row>
				} @empty {
					<div class="no-results">Er zijn geen favorieten opgeslagen.</div>
				}
			</div>
		}
	}

	<ng-template #bottomBarLeft>
		@switch (currentTabSelection()) {
			@case (DataExportSelection.KOLOMSELECTIE) {
				<app-button buttonType="text" (clickit)="changeAllOrNoneSelection()"
					>{{ isAllSelected() ? "Deselecteer" : "Selecteer" }} alles</app-button
				>
			}
		}
	</ng-template>
	<ng-template #bottomBarRight>
		<app-button buttonType="secondary" (clickit)="dialogRef.close()">Annuleren</app-button>
		@switch (currentTabSelection()) {
			@case (DataExportSelection.KOLOMSELECTIE) {
				<app-button [enabled]="kolommenSelection().length > 0" (clickit)="dialogRef.close(exportSelection())">Exporteren</app-button>
			}
			@case (DataExportSelection.FAVORIETEN) {
				<app-button [enabled]="favorietenSelection().length > 0" (clickit)="dialogRef.close(exportSelection())">Exporteren</app-button>
			}
		}
	</ng-template>
</app-base-dialog>

<ng-template #confirmDeleteDialog let-favoriet>
	<app-confirm-dialog caption="Dataexportfavoriet verwijderen" action="Verwijderen">
		Je staat op het punt om de dataexportfavoriet <b>{{ favoriet.naam }}</b> te verwijderen. Weet je het zeker?
	</app-confirm-dialog>
</ng-template>
